import Plus from '@/images/white-plus.inline.svg';

export default Plus;
